import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    event.preventDefault()
    
    const clickedTab = event.currentTarget
    const tabName = clickedTab.dataset.tab
    
    // Update tab active states
    const allTabs = this.element.querySelectorAll('[role="tab"]')
    allTabs.forEach(tab => {
      tab.classList.remove('tab-active')
    })
    clickedTab.classList.add('tab-active')
    
    // Show/hide tab content
    const allContent = this.element.querySelectorAll('[data-tab-content]')
    allContent.forEach(content => {
      if (content.dataset.tabContent === tabName) {
        content.classList.remove('hidden')
      } else {
        content.classList.add('hidden')
      }
    })
  }
}

